import { vuexModule as ClockvineStore } from 'clockvine-vue';

let seismicBraceConfiguration = new ClockvineStore('/actions/anvil-module/seismic-brace-configuration');

export default seismicBraceConfiguration;
